import request from "@/utils/request";
import store from "@/store";
import config from "@/config";
const { baseUrl } = config;
// import axios from "axios";
//所有上传图片的都用这接口，涉及到跨域
//这是个公用图片上传接口
export const uploadImgUrl =
  process.env.NODE_ENV === "production"
    ? `${baseUrl}/Mydb/save_img`
    : "/api/Mydb/save_img";

//富文本的图片上传
export const uploadImgForEditor =
  process.env.NODE_ENV === "production"
    ? `${baseUrl}/Login/tiny_image`
    : "/api/Login/tiny_image";

//上传图片接口
export const uploadImg = (data = {}) => {
  return request({
    url: "Mydb/save_imgflow",
    data
  });
};

//获取系统分类
export const getSystemList = (data = {}) => {
  return request({
    url: "Hqdb/device_system_lists",
    data
  });
};

//获取系部门列表(一级一级获取)
export const getDepList = (data = {}) => {
  return request({
    url: "Hqdb/department_one_lists",
    data
  });
};

//发送短信验证吗
export const getVerCode = (data = {}) => {
  return request({
    url: "User/send_sms_code",
    data
  });
};

//发送短信验证吗
export const setMobile = (data = {}) => {
  return request({
    url: "User/mobile_change",
    data
  });
};

//图片验证码地址
export const codeImgUrl = process.env.NODE_ENV === "production"
  ? `${baseUrl}`
  : "/api" + `/Login/image_code?token=${store.getters.token}`;
export const getImgCode = () => {
  return codeImgUrl + `&t=${Math.random()}`;
}
